import iconSign from './imgs/yiqs.png'
import iconSingCurrent from './imgs/yiqs_current.png';
import iconCancel from './imgs/yiqx.png'
import iconCancelCurrent from './imgs/yiqx_current.png';
import iconTransport from './imgs/yunsz.png'
import iconTransportCurrent from './imgs/yunsz_current.png'
import iconOrder from './imgs/tijdd.png'
import iconOrderCurrent from './imgs/tijdd_current.png'
import iconInStore from './imgs/yirk.png'
import iconInStoreCurrent from './imgs/yirk_current.png';
import iconProcessing from './imgs/rukz.png'
import iconProcessingCurrent from './imgs/rukz_current.png'
import iconPartSigned from './imgs/bufqs.png'
import iconPartSignedCuurent from './imgs/bufqs_current.png'
import iconBidding from './imgs/yjz.png'
import iconBiddingCurrent from './imgs/yjz_current.png'
import iconReject from './imgs/jus.png'
import iconRejectCurrent from './imgs/jus_current.png'
 
const STATUSMAP = {
  SIGNED: 'SIGNED',
  CANCELED: 'CANCELED',
  TRANSPORTING: 'TRANSPORTING',
  CREATED: 'CREATED',
  REJECTED: 'REJECTED',
  BIDDING: 'BIDDING',
  STORED: 'STORED',
  PARTSIGNED: 'PART_SIGNED',
  DELIVERING:'DELIVERING',
  STORING: 'STORING',
  FINISHED: 'FINISHED',
  DELIVERTRANSPORT: 'DELIVER_TRANSPORT',
}

export const STATUSENU = STATUSMAP

export const STATUS = {
  [STATUSMAP.SIGNED]: '已签收',
  [STATUSMAP.CANCELED]: '已取消',
  [STATUSMAP.TRANSPORTING]: '运输中',
  [STATUSMAP.CREATED]: '已下单',
  [STATUSMAP.REJECTED]: '已拒收',
  [STATUSMAP.BIDDING]: '议价中',
  [STATUSMAP.STORED]: '已入库',
  [STATUSMAP.PARTSIGNED]: '部分签收',
  [STATUSMAP.DELIVERING]: '仓库出库处理',
  [STATUSMAP.STORING]: '仓库入库处理',
  [STATUSMAP.FINISHED]: '已完成',
  [STATUSMAP.DELIVERTRANSPORT]: '出库与运输',
}

export const STATUSIMG = {
  [STATUSMAP.SIGNED]: {
    current: iconSingCurrent,
    icon: iconSign
  },
  [STATUSMAP.CANCELED]: {
    current: iconCancelCurrent,
    icon: iconCancel,
  },
  [STATUSMAP.TRANSPORTING]: {
    current: iconTransportCurrent,
    icon: iconTransport
  },
  [STATUSMAP.DELIVERTRANSPORT]: {
    current: iconTransportCurrent,
    icon: iconTransport
  },
  [STATUSMAP.CREATED]: {
    current: iconOrderCurrent,
    icon: iconOrder,
  },
  [STATUSMAP.REJECTED]: {
    current: iconRejectCurrent,
    icon: iconReject,
  },
  [STATUSMAP.BIDDING]: {
    current: iconBiddingCurrent,
    icon: iconBidding
  },
  [STATUSMAP.STORED]: {
    current: iconInStoreCurrent,
    icon: iconInStore
  },
  [STATUSMAP.PARTSIGNED]: {
    current: iconPartSignedCuurent,
    icon: iconPartSigned
  },
  [STATUSMAP.DELIVERING]: {
    current: iconProcessingCurrent,
    icon: iconProcessing
  },
  [STATUSMAP.STORING]: {
    current: iconProcessingCurrent,
    icon: iconProcessing
  },
  [STATUSMAP.FINISHED]: {
    current: iconSingCurrent,
    icon: iconSign
  }
}